import { GregorioGlyph } from '../structures/GregorioGlyph';
import { GregorioLiquescentia, TAIL_LIQUESCENTIA_MASK } from '../enums/GregorioLiquescentia';
import { GregorioNoteElement } from '../structures/GregorioNoteElement';
import { GregorioSign } from '../enums/GregorioSign';
import { GregorioElement, GregorioExtraInfo, GregorioMiscElementInfo } from '../structures/GregorioSyllable';
import { GregorioType } from '../enums/GregorioType';


export function is_tail_liquescentia(liquescentia: GregorioLiquescentia): boolean {
  return (liquescentia & TAIL_LIQUESCENTIA_MASK) !== 0;
}

export function is_initio_debilis(liquescentia: GregorioLiquescentia): boolean {
  return (liquescentia & GregorioLiquescentia.INITIO_DEBILIS) !== 0;
}

export function is_fused(liquescentia: GregorioLiquescentia): boolean {
  return (liquescentia & GregorioLiquescentia.FUSED) !== 0;
}

export function glyph_note_ambitus(
  current_glyph: GregorioGlyph,
  previous_glyph: GregorioGlyph,
): number {
  return current_glyph.notes.notes[0].pitch -
    previous_glyph.notes.notes[previous_glyph.notes.notes.length - 1].pitch;
}

export function is_cavum(notes: GregorioNoteElement[]): boolean {
  return notes.some(note => note.is_cavum);
}

// returns new first_glyph_index
export function cut_before(
  glyphs: GregorioGlyph[],
  elements: GregorioElement[],
  current_glyph_i: number,
  first_glyph_i: number,
): number {
  if (first_glyph_i !== current_glyph_i) {
    close_element(glyphs, elements, current_glyph_i - 1, first_glyph_i);
  }
  return current_glyph_i;
}

// returns new first_glyph_index
export function close_element(
  glyphs: GregorioGlyph[],
  elements: GregorioElement[],
  current_glyph_i: number,
  first_glyph_i: number,
): number {
  gregorio_add_element(glyphs, elements, current_glyph_i, first_glyph_i);
  return current_glyph_i;
}

function gregorio_add_element(
  glyphs: GregorioGlyph[],
  elements: GregorioElement[],
  current_glyph_i: number,
  first_glyph_i: number,
) {
  const element = new GregorioElement();
  element.type = GregorioType.ELEMENT;
  element.glyphs = glyphs.slice(first_glyph_i, current_glyph_i + 1);
  elements.push(element);
}


export function gregorio_add_unpitched_element_as_glyph(
  glyphs: GregorioGlyph[],
  type: GregorioType,
  info: GregorioExtraInfo,
  sign: GregorioSign,
) {
  const next_glyph = new GregorioGlyph();

  next_glyph.type = type;
  next_glyph.misc = new GregorioMiscElementInfo();
  next_glyph.misc.info = info;
  next_glyph.misc.special_sign = sign;

  glyphs.push(next_glyph);
}


export function gregorio_free_one_note(notes: GregorioNoteElement[], note: GregorioNoteElement) {
  const note_index = notes.indexOf(note);
  if (note_index !== -1) {
    notes.splice(note_index, 1);
  }
}
